import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    Typography,
    Modal
} from '@mui/material';
import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import { ConstantActions, FlowBuilderActions } from '../../../Services/_actions/index.js';
import { PaginatedResponse } from '../../../interfaces/Management.interface.ts';
import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';
import { useRecoilState, useRecoilValue } from 'recoil';
import { userInformationAtom } from '../../../Services/_states/auth.js';
import { useNavigate } from 'react-router';
import BotNumberDropdown from '../../Shared/BotNumberDropdown/index.tsx';
import OrganisationDropdown from '../../Shared/OrganisationDropdown/index.tsx';
import { channelListAtom, organisationFilterAtom, organisationResponseAtom } from '../../../Services/_states/index.js';

interface OrganisationBotSelectionModalProps {
    open: boolean;
    onClose: (data: { organisation: any; botNumber: any } | null) => void;
    isEdit: boolean;
    selectedOrganisation: any;
    selectedBot: any;
}

const OrganisationBotSelectionModal: React.FC<OrganisationBotSelectionModalProps> = ({ open, onClose, isEdit, selectedOrganisation,
    selectedBot }) => {
    const { showSnackBar } = useSnackBar();
    const navigate = useNavigate();
    const constantActions = ConstantActions();
    const flowBuilderActions = FlowBuilderActions();
    const loggedInUser = useRecoilValue(userInformationAtom);
    const [organisationRes, setOrganisationRes] = useRecoilState(organisationResponseAtom);
    const [organisationFilter, setOrganisationFilter] = useRecoilState(organisationFilterAtom);

    // const [organisationRes, setOrganisationRes] = useState<PaginatedResponse>({ list: [], pages: 0, count: 0 });
    // const [organisationFilter, setOrganisationFilter] = useState({ page: 0, search: "" });
    const [organisationIsLoading, setOrganisationIsLoading] = useState(false);
    const [channelList, setChannelList] = useRecoilState(channelListAtom);
    const [formData, setFormData] = useState<{ organisation: { organisation_id: string } | null, botNumber: object | null }>({ organisation: null, botNumber: null });
    const [validationErrors, setValidationErrors] = useState({
        organisation: '',
        botNumber: '',
    });

    const fetchOrganisations = async (filterObj) => {
        setOrganisationIsLoading(true);
        try {
            const res = await constantActions.getOrganisationsWithPagination(filterObj);
            if (res?.status === 200 && res?.data) {
                setOrganisationRes(res.data);
            } else {
                showSnackBar('Unexpected response status or data:', 'error');
            }
        } catch (error) {
            showSnackBar('Failed to fetch organizations:', 'error');

        }
        setOrganisationIsLoading(false);
    };
    useEffect(() => {
        if (isEdit) {
            if (loggedInUser?.is_superuser) {
                setFormData({
                    organisation: selectedOrganisation || null,
                    botNumber: selectedBot || null
                });
            } else {
                const organisation = loggedInUser?.profile?.organisation.name || null;
                setFormData({
                    organisation: organisation,
                    botNumber: selectedBot || null
                });
                if (organisation) {
                    fetchChannels(loggedInUser?.profile?.organisation);
                }
            }
        }
    }, [isEdit, selectedOrganisation, selectedBot, loggedInUser]);
    const loadMoreOrganisation = async () => {
        if (organisationFilter.page < (organisationRes.pages || 0)) {
            setOrganisationIsLoading(true);
            let listData: any[] = Array.isArray(organisationRes.list) ? [...organisationRes.list] : [];
            const data = { ...organisationFilter, page: organisationFilter.page + 1 };
            try {
                const res = await constantActions.getOrganisationsWithPagination(data);
                if (res?.status === 200 && res?.data?.list && Array.isArray(res.data.list)) {
                    listData = [...listData, ...res.data.list];
                    setOrganisationRes({ ...res.data, list: listData });
                    setOrganisationFilter(data);
                } else {
                    showSnackBar('Unexpected response structure or status:', 'error');

                }
            } catch (error) {
                showSnackBar('Error loading more organizations:', 'error');
            } finally {
                setOrganisationIsLoading(false);
            }
        }
    };

    const handleSearchOrganisation = (query) => {
        const updatedFilter = { ...organisationFilter, search: query || '', page: 0 };
        setOrganisationFilter(updatedFilter);
        fetchOrganisations(updatedFilter);
    };
    const fetchChannels = async (organisation: any) => {
        setChannelList([]);
        try {
            let res = await flowBuilderActions.whatsappBusinessAccounts(organisation?.organisation_id);
            // console.log("Fetched Channels:", res); 
            if (res?.status === 200 && Array.isArray(res?.data)) {
                setChannelList(res?.data || []);

                if (res?.data?.length === 1) {
                    setFormData({
                        ...formData,
                        botNumber: res?.data[0],
                        organisation: organisation,
                    });
                    if (!loggedInUser?.is_superuser) {
                        onClose({
                            ...formData,
                            botNumber: res?.data[0],
                            organisation: organisation,
                        });
                    }
                } else if (res?.data?.length === 0) {
                    setFormData({
                        ...formData,
                        organisation: organisation,
                        botNumber: null,
                    });
                    showSnackBar('Bot number is not available for this organisation:', 'error');
                } else {
                    setFormData({
                        ...formData,
                        organisation: organisation,
                        botNumber: selectedBot || null,
                    });
                }
            } else {
                showSnackBar('Unexpected response structure or status:', 'error');
            }
        } catch (error) {
            showSnackBar(error?.toString(), 'error');
        }
    };


    const handleSelectOrganisation = async (option: any | null) => {
        // setFormData({ ...formData, organisation: option });
        if (option?.organisation_id) {
            fetchChannels(option);
            setFormData({ ...formData, botNumber: null });
        }
        else {
            setFormData({ ...formData, botNumber: null, organisation: null });
            setChannelList([]);
        }
    };

    useEffect(() => {
        if (loggedInUser?.is_superuser) {
            //  console.log("loggedInUser?.is_superuser")
            // fetchOrganisations(organisationFilter);
        } else {
            setFormData({ ...formData, organisation: loggedInUser?.loggedInUser?.profile?.organisation })
            fetchChannels(loggedInUser?.profile?.organisation);
        }
    }, []);

    const handleSubmit = () => {
        const errors: any = {};
        if (loggedInUser?.is_superuser) {
            if (!formData.organisation) {
                errors.organisation = 'Organisation is required';
            }
        }

        if (!formData.botNumber) {
            errors.botNumber = 'Bot number is required';
        }

        setValidationErrors(errors);

        if (Object.keys(errors).length === 0) {
            onClose(formData);
        }
    };
    return (
        <Modal open={open} onClose={() => { onClose(null); }}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    borderRadius: '8px',
                    p: 3,
                    width: 400,
                    maxHeight: '90vh',
                    overflowY: 'auto',
                }}
            >
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    Select
                </Typography>

                {loggedInUser?.is_superuser &&
                    <SearchableDropdown
                        options={organisationRes?.list || []}
                        label={
                            <Typography component="span">
                                Select Organisation <span style={{ color: 'red' }}>*</span>
                            </Typography>
                        }
                        value={formData?.organisation || null}
                        fetchMoreOptions={organisationFilter.page < (organisationRes?.pages || 0) ? loadMoreOrganisation : undefined}
                        onSearch={handleSearchOrganisation}
                        labelKey="name"
                        valueKey="organisation_id"
                        onChange={(org) => handleSelectOrganisation(org)}
                        loading={organisationIsLoading}
                        error={!!validationErrors?.organisation}
                        errorMessage={validationErrors?.organisation}
                        sx={{ mt: 2 }}
                    />
                }
                {/* {loggedInUser?.is_superuser && (
                    <OrganisationDropdown
                        value={formData?.organisation || null}
                        onChange={(selected) => {
                            setFormData({ ...formData, organisation: selected });
                            setValidationErrors({ ...validationErrors, organisation: '' });
                        }}
                        error={!!validationErrors?.organisation}
                        errorMessage={validationErrors?.organisation}
                        label={"Select Organisation"}
                    />
                )} */}

                <SearchableDropdown
                    label={
                        <Typography component="span">
                            Bot Number <span style={{ color: 'red' }}>*</span>
                        </Typography>
                    }
                    // options={channelList || []}
                    options={channelList.map((channel: any) => ({
                        ...channel,
                        displayLabel: `${channel.app_name} (${channel.wa_phone_number})`
                    }))}
                    value={formData?.botNumber || null}
                    onChange={(data) => {
                        setFormData({ ...formData, botNumber: data });
                        setValidationErrors({ ...validationErrors, botNumber: '' });
                    }}
                    labelKey='displayLabel'
                    valueKey='wa_phone_number'
                    error={!!validationErrors.botNumber}
                    errorMessage={validationErrors.botNumber}
                    sx={{ mt: 2 }}
                    disabled={channelList?.length === 1}
                />
                {/* <BotNumberDropdown
                    organisation={formData?.organisation || null}
                    onChange={(selected) => {
                        setFormData({ ...formData, botNumber: selected });
                        setValidationErrors({ ...validationErrors, botNumber: '' });
                    }}
                    value={formData?.botNumber}
                    error={!!validationErrors?.botNumber}
                    errorMessage={validationErrors?.botNumber}
                    // disabled={false}
                    label={
                        <Typography component="span">
                            Bot Number <span style={{ color: 'red' }}>*</span>
                        </Typography>
                    }

                /> */}
                <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
                    <Button variant="outlined" onClick={() => { isEdit ? onClose(null) : navigate(-1); }} size="small">
                        Back
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        color="primary"
                        size="small"
                    >
                        Submit
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default OrganisationBotSelectionModal;
